import Api from './Api';
import Configuracao from '../util/Configuracao';
import { parse } from 'date-fns';

class BeneficiarioApi extends Api {
  async consultarFluxo (filter) {
    try {
      const fluxoUrl = Configuracao.getConfiguracao().urlBeneficiarioConsultarFluxo + '/' + filter.tipo + '/data_inicio/' + filter.from + '/data_fim/' + filter.to;
      const response = await this.fetch(fluxoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarBeneficiarios (filter) {
    try {
      const beneficiarioUrl = Configuracao.getConfiguracao().urlBeneficiarioConsultar + filter.carteira + '/codServidor/' + filter.codServidor + '/nome/' + filter.nome;
      const response = await this.fetch(beneficiarioUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarHistoricoAdesao (filter) {
    try {
      const historicoAdesaoUrl = Configuracao.getConfiguracao().urlHistoricoAdesaoConsultar + filter.codServidor;
      const response = await this.fetch(historicoAdesaoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirTitular (filter) {
    const incluirTitularUrl = Configuracao.getConfiguracao().urlIncluirTitular;
    const response = await this.fetch(incluirTitularUrl, 'put', filter);
    return response;
  }
  async incluirDependente (filter) {
    const incluirDependenteUrl = Configuracao.getConfiguracao().urlIncluirDependente;
    const response = await this.fetch(incluirDependenteUrl, 'put', filter);
    return response;
  }
  async excluirTitular (filter) {
    const excluirTitularUrl = Configuracao.getConfiguracao().urlExcluirTitular;
    const response = await this.fetch(excluirTitularUrl, 'put', filter);
    return response;
  }
  async exlcuirDependente (filter) {
    const excluirDependenteUrl = Configuracao.getConfiguracao().urlExcluirDependente;
    const response = await this.fetch(excluirDependenteUrl, 'put', filter);
    return response;
  }
  async alterarTitularidade (filter, codTitularidade) {
    var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
    const alterarTitularidadeUrl = Configuracao.getConfiguracao().urlAlterarTitularidade + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/titularidade/' + codTitularidade;
    const response = await this.fetch(alterarTitularidadeUrl, 'put');
    return response;
  }

  async consultarDependencias (filter) {
    try {
      var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
      const urlDependencias = Configuracao.getConfiguracao().urlConsultarDependencias + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/carteira/' + filter.numMatriculaTST + '/titularidade/' + filter.titularidade;
      const response = await this.fetch(urlDependencias, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return 'S';
    }
  }

  async salvarDataInicial (filter, data) {
    var dataNula = parse(new Date(null));
    var dtaParam = data === null || data === '' ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
    const salvarDataInicialUrl = Configuracao.getConfiguracao().urlSalvarDataInicial + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/data/' + dtaParam + '/titularidade/' + filter.titularidade;
    const response = await this.fetch(salvarDataInicialUrl, 'put');
    return response;
  }

  async salvarDataFim (filter, data) {
    var dataNula = parse(new Date(null));
    var dtaParam = data === null || data === '' ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
    const salvarDataFimUrl = Configuracao.getConfiguracao().urlSalvarDataFim + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/data/' + dtaParam + '/titularidade/' + filter.titularidade;
    const response = await this.fetch(salvarDataFimUrl, 'put');
    return response;
  }

  async consultarLimitesDataInicioTitular (filter, data) {
    try {
      const consultarLimitesDataInicioTitularUrl = Configuracao.getConfiguracao().urlConsultarLimitesDataInicioTitular + filter.seqBeneficiario + '/codServidor/' + filter.codServidor + '/dataInicio/' + parse(data);
      const response = await this.fetch(consultarLimitesDataInicioTitularUrl, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async consultarLimitesDataInicioDependente (filter) {
    try {
      const consultarLimitesDataInicioDependenteUrl = Configuracao.getConfiguracao().urlConsultarLimitesDataInicioDependente + filter.seqBeneficiario;
      const response = await this.fetch(consultarLimitesDataInicioDependenteUrl, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async consultarLimitesDataFimTitular (filter, data) {
    var dataNula = parse(new Date(null));
    var dtaParam = data === null || data === '' ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    try {
      const consultarLimitesDataFimTitularUrl = Configuracao.getConfiguracao().urlConsultarLimitesDataFimTitular + filter.seqBeneficiario + '/codServidor/' + filter.codServidor + '/dataFim/' + dtaParam;
      const response = await this.fetch(consultarLimitesDataFimTitularUrl, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }

  async consultarLimitesDataFimDependente (filter) {
    try {
      var seqDep = filter.seqDependente === null || filter.seqDependente === undefined ? 0 : filter.seqDependente;
      const consultarLimitesDataFimDependenteUrl = Configuracao.getConfiguracao().urlConsultarLimitesDataFimDependente + filter.seqBeneficiario + '/seq_dependente/' + seqDep + '/carteira/' + filter.numMatriculaTST;
      const response = await this.fetch(consultarLimitesDataFimDependenteUrl, 'get');
      return response.data;
    } catch (error) {
      console.error(error);
      return {};
    }
  }
  async consultarNomes () {
    try {
      const nomesUrl = Configuracao.getConfiguracao().urlConsultarNomesTodosBeneficiarios;
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarBeneficiarioInternado (carteira, dtaAtendimento) {
    try {
      const beneficiarioInternadoUrl = Configuracao.getConfiguracao().urlBeneficiarioInternado + carteira + '/data_atendimento/' + dtaAtendimento;
      const response = await this.fetch(beneficiarioInternadoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarTelefones (codServidor, seqDependenteRH) {
    try {
      const urlTelefonesBeneficiario = Configuracao.getConfiguracao().urlTelefonesBeneficiario + codServidor + '/' + seqDependenteRH;
      const response = await this.fetch(urlTelefonesBeneficiario);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarHistoricos (codServidor, seqDependenteRH) {
    try {
      const urlHistoricosBeneficiario = Configuracao.getConfiguracao().urlHistoricosBeneficiario + codServidor + '/' + seqDependenteRH;
      const response = await this.fetch(urlHistoricosBeneficiario);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEmails (codServidor, seqDependenteRH) {
    try {
      const urlEmailsBeneficiario = Configuracao.getConfiguracao().urlEmailsBeneficiario + codServidor + '/' + seqDependenteRH;
      const response = await this.fetch(urlEmailsBeneficiario);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEnderecos (codServidor, seqDependenteRH) {
    try {
      const urlEnderecosBeneficiario = Configuracao.getConfiguracao().urlEnderecosBeneficiario + codServidor + '/' + seqDependenteRH;
      const response = await this.fetch(urlEnderecosBeneficiario);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarRequisitado (codServidor, seqDependenteRH) {
    try {
      const urlRequisitadoBeneficiario = Configuracao.getConfiguracao().urlRequisitadoBeneficiario + codServidor + '/' + seqDependenteRH;
      const response = await this.fetch(urlRequisitadoBeneficiario);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarRequisitadoHistorico (codServidor, seqDependenteRH) {
    try {
      const urlRequisitadoHistBeneficiario = Configuracao.getConfiguracao().urlRequisitadoHistBeneficiario + codServidor + '/' + seqDependenteRH;
      const response = await this.fetch(urlRequisitadoHistBeneficiario);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default BeneficiarioApi;
